function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "close",
  d: "M14.2,11.86l9.347-9.13a1.492,1.492,0,0,0,0-2.148,1.58,1.58,0,0,0-2.2,0L12,9.712,2.655.581a1.58,1.58,0,0,0-2.2,0,1.492,1.492,0,0,0,0,2.148L9.8,11.86.456,20.99a1.492,1.492,0,0,0,0,2.148,1.581,1.581,0,0,0,2.2,0L12,14.008l9.347,9.13a1.581,1.581,0,0,0,2.2,0,1.492,1.492,0,0,0,0-2.148Zm0,0",
  transform: "translate(0 -0.136)"
});

var SvgIcClose = function SvgIcClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.005,
    height: 23.447,
    viewBox: "0 0 24.005 23.447",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_close.88e9e13d.svg";
export { ForwardRef as ReactComponent };